import { useQuery } from "@tanstack/react-query";
import type { AuditListItem } from "@/hooks/use-audits";
import { techPartnerKeys } from "@/lib/query";

export interface TechPartnerDashboard {
  products: string[];
  metrics: {
    passRate: number;
    totalInScope: number;
    completed: number;
    remainingProjects: number;
  };
  audits: AuditListItem[];
}

export function useTechPartnerDashboard() {
  return useQuery({
    queryKey: techPartnerKeys.dashboard,
    queryFn: async (): Promise<TechPartnerDashboard> => {
      const res = await fetch("/api/tech-partner/dashboard");
      if (!res.ok) throw new Error("Failed to load the Tech Partner dashboard");
      const json = await res.json();
      return json.data;
    },
  });
}
